import useFailedPay from 'pages/park_car_summary/ParkCarSummaryHooks/useFailedPay'
import React from 'react'
import { useTimer } from 'react-timer-hook'

export const ExpirationPopupTimer = ({
  expiryTimestamp,
}: {
  expiryTimestamp: Date
}) => {
  const { showExpiredPopup } = useFailedPay()

  useTimer({ expiryTimestamp, onExpire: () => showExpiredPopup() })

  return <></>
}
